import { Browser } from '@capacitor/browser';
import { NATIVE } from './platform.js';

/** Open an address outside the app's pages: the system browser sheet in the iPhone app (a .pkpass, a game), the same tab on the web. */
export async function openExternal(url: string): Promise<void> {
  if (NATIVE) await Browser.open({ url });
  else window.location.href = url;
}

/**
 * Open a page from outside Tikkas (a Google review, a partner's site) and keep the app where it is: the browser sheet
 * in the iPhone app, a new tab on the web. Call it straight from the tap (before any await), or Safari blocks the tab.
 */
export function openLink(url: string): void {
  if (NATIVE) {
    void Browser.open({ url });
    return;
  }
  const w = window.open(url, '_blank');
  if (w) w.opener = null;
  else window.location.href = url; // pop-ups blocked: go there in this tab instead
}
